// src/client/game/core/levels/LevelRun.ts
import type { Level } from "./Level";

/**
 * Tracks per-level score as a delta from the run's total score.
 * This avoids invasive refactors to existing score writes.
 */
export class LevelRun {
  private startScore = 0;

  constructor(public readonly level: Level) {}

  /** Call at run start (or restart) to anchor level score. */
  start(totalScore: number): void {
    this.startScore = totalScore;
  }

  /** Current score earned within this level. */
  score(totalScore: number): number {
    return Math.max(0, totalScore - this.startScore);
  }

  /** 0..1 */
  percent(totalScore: number): number {
    const s = this.score(totalScore);
    const t = this.level.targetScore;
    if (t <= 0) return 1;
    return Math.max(0, Math.min(1, s / t));
  }

  isComplete(totalScore: number): boolean {
    return this.score(totalScore) >= this.level.targetScore;
  }
}
